"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateUrl = validateUrl;
const core_1 = require("@alcumus/core");
const is_valid_domain_1 = __importDefault(require("is-valid-domain"));
const ip_address_1 = require("ip-address");
function validateUrl(url) {
    const parsedUrl = new URL(url);
    // Verify protocol is http or https
    if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') {
        throw new Error(`Invalid protocol ${parsedUrl.protocol}. Only http and https are allowed.`);
    }
    // reject ip addresses
    const isIPv4 = ip_address_1.Address4.isValid(parsedUrl.hostname);
    const isIPv6 = ip_address_1.Address6.isValid(parsedUrl.hostname);
    if (isIPv4 || isIPv6) {
        throw new Error(`IP addresses are not allowed: ${parsedUrl.hostname}`);
    }
    const isDevelopmentEnvironment = core_1.Utilities.ProcessEnv.isDevelopmentEnvironment();
    const isDomainOk = (0, is_valid_domain_1.default)(parsedUrl.hostname, {
        subdomain: true,
        wildcard: false,
        allowUnicode: false,
        topLevel: false,
    });
    if (!isDevelopmentEnvironment && !isDomainOk) {
        throw new Error(`Invalid domain: ${parsedUrl.hostname}`);
    }
    // Verify domain is in allowed list
    const allowedDomains = [
        core_1.Utilities.ProcessEnv.getValue('SAFETY_INTELLIGENCE_API')
    ];
    for (const allowedDomain of allowedDomains) {
        if (allowedDomain && allowedDomain.indexOf(parsedUrl.hostname) > -1) {
            return parsedUrl.href;
        }
    }
    const possibleDomains = allowedDomains.map(x => x).join(', ');
    throw new Error(`Domain ${parsedUrl.hostname} must be one of: ${possibleDomains}`);
}
